// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".persona-selector{align-items:center;display:flex;flex:1 0 auto;padding:24px 0}.persona-selector__col{align-items:center;display:flex;flex-direction:column;grid-column:span 4}@media(max-width:543px){.persona-selector__col{grid-column:span 12}}.persona-selector__btn{justify-content:center;order:2;width:100%}.persona-selector__img{order:1}.persona-selector__description{order:3;padding:12px 8px 0;text-align:center}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
